import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const WS_URL = `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });

export function errMsg(e) {
  if (!e?.response) return "Connexion impossible. Vérifiez votre réseau et réessayez.";
  const detail = e.response.data?.detail;
  if (detail == null) return "Une erreur est survenue. Merci de réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || "").filter(Boolean).join(" ") || "Données invalides.";
  return detail.msg || "Une erreur est survenue.";
}
